import axios from "axios";
import { useEffect, useState } from "react";

const AbsensiUserForm = () => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");

  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [hasAbsen, setHasAbsen] = useState(false);
  const [absensiInfo, setAbsensiInfo] = useState(null);
  const [userForm, setUserForm] = useState(null);

  const [showPopup, setShowPopup] = useState(false);
  const [showForm, setShowForm] = useState(false);

  /* =====================================================
     LOAD DATA ABSENSI UNTUK USER LOGIN
  ===================================================== */
  useEffect(() => {
    const fetchUserAbsensi = async () => {
      try {
        // 1️⃣ cek apakah user sudah absen
        const userRes = await axios.get(
          `${process.env.REACT_APP_API_URL}api/absensiguru/user`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (userRes.data.length > 0) {
          const abs = userRes.data[0];

          setHasAbsen(true);
          setAbsensiInfo({
            tanggal: abs.tanggal,
            tahun: abs.tahun,
            semester: abs.semester,
          });

          setLoading(false);
          return;
        }

        // 2️⃣ jika belum, cari absensi yang masih terbuka
        const allRes = await axios.get(
          `${process.env.REACT_APP_API_URL}api/absensiguru`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        const openAbsensi = allRes.data.find((item) => item.status === false);

        if (openAbsensi) {
          setAbsensiInfo({
            tanggal: openAbsensi.tanggal,
            tahun: openAbsensi.tahun,
            semester: openAbsensi.semester,
          });

          setUserForm({
            guruId: userId,
            namaGuru: userName,
            sakit: 0,
            izin: 0,
            tanpaKeterangan: 0,
            keterangan: "",
            tanggal: openAbsensi.tanggal,
            tahun: openAbsensi.tahun,
            semester: openAbsensi.semester,
          });

          setShowPopup(true);
        }
      } catch (err) {
        console.error("Gagal mengambil absensi:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserAbsensi();
  }, [token, userId, userName]);

  /* =====================================================
     HANDLE STATUS BUTTON
  ===================================================== */
  const handleStatusChange = (status) => {
    setUserForm((prev) => ({
      ...prev,
      sakit: status === "sakit" ? 1 : 0,
      izin: status === "izin" ? 1 : 0,
      tanpaKeterangan: status === "tk" ? 1 : 0,
    }));
  };

  /* =====================================================
     HANDLE KETERANGAN
  ===================================================== */
  const handleKeteranganChange = (value) => {
    setUserForm((prev) => ({
      ...prev,
      keterangan: value,
    }));
  };

  /* =====================================================
     SUBMIT ABSENSI
  ===================================================== */
  const handleSubmit = async () => {
    if (!userForm || loadingSubmit) return;

    try {
      setLoadingSubmit(true);

      await axios.post(
        `${process.env.REACT_APP_API_URL}api/absensiguru`,
        {
          tahun: userForm.tahun,
          semester: userForm.semester,
          tanggal: userForm.tanggal,
          guruId: userForm.guruId,
          sakit: userForm.sakit,
          izin: userForm.izin,
          tanpaKeterangan: userForm.tanpaKeterangan,
          keterangan: userForm.keterangan,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      alert("Absensi berhasil disimpan ✅");

      setHasAbsen(true);
      setShowPopup(false);
      setShowForm(false);
    } catch (err) {
      console.error(err);
      alert("Gagal menyimpan absensi");
    } finally {
      setLoadingSubmit(false);
    }
  };

  /* =====================================================
     LOADING SCREEN
  ===================================================== */
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600 font-semibold">Memuat data absensi...</p>
      </div>
    );
  }

  /* =====================================================
     JIKA SUDAH ABSEN
  ===================================================== */
  if (hasAbsen && absensiInfo) {
    return (
      <div className="fixed top-32 left-4 z-50 bg-white shadow-lg rounded-lg p-4 w-72">
        <p className="font-semibold text-sm mb-1">
          {new Date(absensiInfo.tanggal).toLocaleDateString()}
        </p>
        <p className="text-green-600 font-semibold text-sm">
          Anda sudah absen ✅
        </p>
      </div>
    );
  }

  /* =====================================================
     POPUP FORM ABSENSI
  ===================================================== */
  return (
    <>
      {showPopup && (
        <div className="fixed top-32 left-4 z-50">
          <button
            onClick={() => setShowForm(!showForm)}
            className="bg-red-600 text-white px-4 py-2 rounded shadow-lg hover:bg-red-700"
          >
            {showForm ? "Tutup Absensi" : "Isi Absensi"}
          </button>

          {showForm && userForm && (
            <div className="mt-2 bg-white rounded-lg shadow-md w-80 p-4">
              <h2 className="font-bold mb-2 text-center">Absensi Hari Ini</h2>

              <p className="font-semibold mb-2 text-sm">{userForm.namaGuru}</p>

              <div className="flex flex-wrap gap-2 mb-3">
                {["hadir", "izin", "sakit", "tk"].map((status) => {
                  const active =
                    status === "tk"
                      ? userForm.tanpaKeterangan === 1
                      : status === "sakit"
                        ? userForm.sakit === 1
                        : status === "izin"
                          ? userForm.izin === 1
                          : userForm.sakit === 0 &&
                            userForm.izin === 0 &&
                            userForm.tanpaKeterangan === 0;

                  return (
                    <button
                      key={status}
                      onClick={() => handleStatusChange(status)}
                      className={
                        active
                          ? "bg-blue-600 text-white px-3 py-1 rounded"
                          : "bg-gray-200 px-3 py-1 rounded"
                      }
                    >
                      {status === "tk"
                        ? "Tanpa Keterangan"
                        : status.charAt(0).toUpperCase() + status.slice(1)}
                    </button>
                  );
                })}
              </div>

              <input
                type="text"
                placeholder="Keterangan (opsional)"
                value={userForm.keterangan}
                onChange={(e) => handleKeteranganChange(e.target.value)}
                className="border p-2 rounded w-full mb-3"
              />

              <button
                onClick={handleSubmit}
                disabled={loadingSubmit}
                className="bg-green-700 text-white px-6 py-2 rounded w-full"
              >
                {loadingSubmit ? "Menyimpan..." : "Submit"}
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default AbsensiUserForm;
